import * as Debug from 'debug';
import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UserService} from '../shared/services/user_service';
import {Util} from '../shared/util/util';

import { ContactFormModalComponent } from '../shared/contact-form-modal/contact-form-modal.component';

@Component({
  templateUrl: './why-publish.component.html',
  styleUrls: ['./why-publish.component.scss']
})
export class WhyPublishComponent implements OnInit, OnDestroy {
  public isLoggedIn = false;
  public user: any = {};
  public overTheTop = false;
  public showMobileMenu = false;
  private userStatusChange: any;

  constructor(private modalService: NgbModal,
    private userService: UserService,
    private util: Util,
    private router: Router, private route: ActivatedRoute) {
  }

  @HostListener('window:scroll', ['$event']) headerType() {
    const topOffset = window.pageYOffset || document.documentElement.scrollTop;
    this.overTheTop = topOffset > 0 ? true : false;
  }

  ngOnInit() {
    this.user = this.route.snapshot.data.user;
    this.isLoggedIn = (this.user && this.user.lastName) ? true : false;

    this.userStatusChange = this.userService.curUser$.subscribe(() => {
      this.isLoggedIn = this.userService.isLoggedIn();
    });
  }

  public triggerMobileMenu(): void {
    this.showMobileMenu = !this.showMobileMenu;
  }

  public openContactModal(): void {
    const modalRef = this.modalService.open(ContactFormModalComponent);
  }

  public logOut(): void {
    this.userService.logout().then(
      () => {
        this.isLoggedIn = false;
        this.user = null;
        this.router.navigate(['/why-publish']);
      }
    ).catch (ex => {
      console.error('Error ', ex);
      this.router.navigate(['/']);
    });
  }

  ngOnDestroy() {
    if (this.userStatusChange) {
      this.userStatusChange.unsubscribe();
    }
  }
}
